<app-page-header subtitle="CRM functies">
    <div class="pe-3" indicator>
        <input [value]="search()" (input)="onSearchChange($any($event.target).value)" matInput placeholder="Zoeken" />
    </div>
</app-page-header>

<div class="container-fluid">
    @if (functions()?.length || roles()?.length) {
        <table class="table table-hover">
            <thead>
                <tr class="header-row">
                    <th class="role-header"></th>
                    <th [attr.colspan]="roles()?.length + 1">
                        <b>Rollen</b>
                    </th>
                    <th class="after"></th>
                </tr>
                <tr>
                    <th class="feature feature-name">
                        <b>Functies uit CRM</b>
                    </th>
                    <th>
                        <div class="role-name">Aantal gebruikers</div>
                    </th>
                    @for (role of roles(); track role.key) {
                        <th [title]="role.description">
                            <div class="role-name">
                                @if (role.is_unique) {
                                    <i class="fas fa-star ml-1"></i>
                                }
                                @if (role.restricted) {
                                    <i class="fas fa-lock ml-1"></i>
                                }
                                {{ role.name }}
                            </div>
                        </th>
                    }
                    <th class="after"></th>
                </tr>
            </thead>
            @for (func of filteredFunctions(); track func.key) {
                <tr>
                    <th class="feature feature-side">
                        {{ func.name }}
                    </th>
                    <td class="curpoint user-select-none" (dblclick)="navigateToUsers(func.name)">
                        {{ func.users_count }}
                    </td>
                    @for (role of roles(); track role.key) {
                        <td class="checkox-td" [title]="role.name">
                            <mat-checkbox
                                [checked]="func | functionHasRole: role"
                                [disabled]="isProduction || (func | isRoleDisabled: role : roles())"
                                (change)="toggleRole($event, func, role)">
                            </mat-checkbox>
                        </td>
                    }
                    <th class="after">
                        {{ func.key }}
                    </th>
                </tr>
            } @empty {
                <tr class="text-center p-5">
                    Geen functies gevonden
                </tr>
            }
        </table>
    } @else {
        <div class="text-center p-5">
            <i class="fas fa-spinner fa-spin fa-3x"></i>
            <p class="mt-3">Gegevens laden...</p>
        </div>
    }
</div>
